var entityMapBasic = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': '&quot;',
    "'": '&#39;',
    "/": '&#x2F;'
};

export function escapeTags(str) {
    return String(str).replace(/[&<>"'\/]/g, function (s) {
        return entityMapBasic[s];
    });
}


const entityMap = {
    '"': '&quot;',
    // '&': '&amp;', // с бакенда факты идут уже заменой "<" и ">" на '&lt;' и '&gt;'
    //  поэтому если подменять сивол '&' то ломается отображение "<" и ">"
    '\'': '&#39;',
    '/': '&#x2F;',
    '<': '&lt;',
    '>': '&gt;',
    '{': '{&#8205;',
    '}': '&#8205;}',
};

// This function escape HTML but keep highligting tags
export function escapeHtml(string, notAllows = false, amp = false) {

    if (string === null || (string && string.trim && string.trim() === 'null')) return '';

    if (typeof string !== 'string') return string;

    if (amp) {
        string = string.replaceAll('&', '&amp;');
    }

    const allows = {
        '<b style="background-color: yellow">': 'fgksdroptipmhgasterte4589e5',
        "<b style='background-color: yellow'>": 'fgksdroptipmhgasterte4589e5',
        '</b>': 'sdfsdisdifoisdfiolsdafoewriu',
        '<highlight>': 'sjfowerogurthudrsoirtyhorttd',
        '</highlight>': 'dsfsdkfsdfsdflksdflksdfjsdlf',
        '<z0>': '0fdlgdsgkds;ldvkzfg;dsrgfdr',
        '</z0>': '0lkvbccl;gjfdgfsdndfg;nd',
        '<z1>': '1lcvkdfzogmikfdopgmidsgfijyd',
        '</z1>': '1fvgdzfrotspopobcsfsef5thf',
        '<z2>': '2cxmv;ifjndsriunsdinudsri',
        '</z2>': '2zdxcfsdefijsijgbicjfxgd',
        '<z3>': '3cvfmdxfjdsfjsfjdslk',
        '</z3>': '3htdklfkdhkmlsjfsdlfsdmlf',
        '<z4>': '4kgchjffgndfnfjrsdjnfgjn',
        '</z4>': '4klhfghghjncghgyhjukuhf',
        '<z5>': '5gfhndxzcfdszfgdghfghfcg',
        '</z5>': '5mhhgdgfdsgdgdfgfdsgdfzg',
        '<z6>': '6gfdgdrsfgdsfgdfgdfdfg',
        '</z6>': '6fdgkdslkljlflkfgjdsfsd',
        '<z7>': '7hdfsfd;dfgkdsdfgd',
        '</z7>': '7dgsddsfgfdsgfdsgdfg',
        '<z8>': '8fghsdstgvuiytdstte',
        '</z8>': '8bhdfrtyghdrjgyjgf',
    };

    Object.keys(allows).map(a => {
        const re = new RegExp(a, 'g');
        const s = notAllows ? '' : allows[a];
        string = string.replace(re, s);
    });

    string = string.replace(/[\{\}<>"'\/]/g, (s, i) => {
        return entityMap[s];
    });

    if (!notAllows) {
        Object.keys(allows).map(a => {
            const re = new RegExp(allows[a], 'g');
            string = string.replace(re, a);
        });
    }

    return string;
}




// WEBPACK FOOTER //
// ./src/util/escape.js